import NutritionInformation from './NutritionInformation';
import { NutritionInformationProps } from './types';
export default NutritionInformation;
export type { NutritionInformationProps };
